import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
  Chip,
  Box,
  TextField,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "../globals";
import { supabase } from "../supabaseClient";
import { Add } from "@mui/icons-material";

const AddDevopsBoardMappingModal = ({ open, onClose, repositories }) => {
  const [selectedRepo, setSelectedRepo] = useState("");
  const [tag, setTag] = useState("");

  function getRepoId(repoName) {
    return repositories.find((repo) => repo.repo_name === repoName)?.id;
  }

  const handleRepoChange = (event) => {
    const { value } = event.target;
    setSelectedRepo(value);
  };

  const handleBoardKeyChange = (event) => {
    setTag(event.target.value);
  };

  const handleSubmit = async () => {
    let repoId = getRepoId(selectedRepo);
    if (!repoId) {
      return;
    }
    try {
      const authToken = (await supabase.auth.getSession()).data.session
        .access_token;
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      let body = { tag: tag, repo_id: repoId };
      await axios.post(`${API_URL}/add-azure-devops-mapping`, body, { headers });
    } catch (error) {
      console.error("Error adding board mapping:", error);
    }
    onClose(); // Close the modal after submission
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Board Mapping</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Configure your board mapping by selecting repositories and specifying
          the tag you want to relate with the repository.
        </Typography>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Repository</InputLabel>
          <Select
            value={selectedRepo}
            onChange={handleRepoChange}
            input={<OutlinedInput id="select-repository" label="Repository" />}
            renderValue={(selected) => selected}
          >
            {repositories.map((repo) => (
              <MenuItem key={repo.repo_name} value={repo.repo_name}>
                {repo.repo_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Item Tag"
          variant="outlined"
          fullWidth
          value={tag}
          onChange={handleBoardKeyChange}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{
            width: "100%",
            mx: 2,
            mb: 2,
            py: 2,
            backgroundColor: "background.paper",
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDevopsBoardMappingModal;
